import { definePreset } from '@primeuix/themes';

/**
 * Adds standard overrides that will apply across themes.
 */
export function addPresetsToTheme(theme: any) {
  return definePreset(theme, {
    semantic: {
      formField: {
        paddingX: '0.1rem',
        paddingY: '0.1rem',
        border: {
          radius: '0px'
        }
      },
      surface: '{surface.200}',
      primary: {
        50: '{indigo.50}',
        100: '{indigo.100}',
        200: '{indigo.200}',
        300: '{indigo.300}',
        400: '{indigo.400}',
        500: '{indigo.500}',
        600: '{indigo.600}',
        700: '{indigo.700}',
        800: '{indigo.800}',
        900: '{indigo.900}',
        950: '{indigo.950}'
      },
      colorScheme: {
        light: {
          surface: {
            0: '{neutral.100}',
            50: '{neutral.200}',
            100: '{neutral.300}',
            200: '{neutral.400}',
            300: '{neutral.500}',
            400: '{neutral.600}',
            500: '{neutral.700}',
            600: '{neutral.800}',
            700: '{neutral.900}',
            800: '{neutral.950}'
          }
        },
        dark: {
          surface: {
            0: '#ffffff',
            50: '{neutral.50}',
            100: '{neutral.100}',
            200: '{neutral.200}',
            300: '{neutral.300}',
            400: '{neutral.400}',
            500: '{neutral.500}',
            600: '{neutral.600}',
            700: '{neutral.700}',
            800: '{neutral.800}',
            900: '{neutral.900}',
            950: '{neutral.950}'
          }
        }
      }
    },
    // Use Semantic whenever possible
    components: {
      inputtext: {
        root: {
          borderRadius: '0px',
          paddingX: '.5rem'
        }
      },
      button: {
        root: {
          sm: {
            paddingX: '0.2rem',
            paddingY: '0.2rem'
          }
        }
      },
      togglebutton: {
        root: {
          padding: '0.25rem'
        }
      },
      toggleswitch: {
        root: {
          height: '1.1rem',
          width: '2rem',
        },
        handle: {
          size: '1rem'
        }
      },
      datatable: {
        headerCell: {
          padding: '.1rem .1rem'
        },
        bodyCell: {
          padding: '.05rem'
        }
      },
      panel: {
        header: {
          padding: '.25rem'
        },
        content: {
          padding: '.1rem'
        }
      },
      toolbar: {
        root: {
          gap: '0.1rem',
          borderRadius: '0px'
        }
      },
      select: {
        dropdown: {
          width: '1.5rem'
        },
        root: {
          paddingX: '0.1rem',
          paddingY: '0.1rem'
        }
      },
      multiselect: {
        root: {
          paddingX: '0.1rem',
          paddingY: '0.1rem'
        }
      },
      tabs: {
        tab: {
          padding: '0.25rem',
          fontWeight: '450',
        }
      },
      // fieldset: {
      //   padding: '0.2rem',
      //   legend: {
      //     fontSize: 'xs',
      //     fontWeight: 200
      //   }
      // }

    }
  });
}
